import { useContext, useState } from "react";
import { Form, Col, Row, Button, Select, Typography } from "antd";
import { useSubmit, getCurrencySymbol, InputMoney } from "antdash";
import { ODDS_FORMATS, ODDS_FORMAT_OPTIONS } from "betui";
import AppContext from "../../context/AppContext";
import staffApi from "../../api/staff";

const { Title } = Typography;

const NewStaffRunner = ({ user, onSuccess }) => {
  const { config } = useContext(AppContext);
  const [currencySymbol, setCurrencySymbol] = useState(config.BASE_CURRENCY);

  const currencyOptions = Object.keys(config.CURRENCY_SYMBOLS).map((k) => ({
    label: k,
    value: k,
  }));

  const submit = (formData) =>
    staffApi.addStaffRunner({ user_id: user.id, ...formData });

  const success = (res) => {
    console.log(res);
    onSuccess();
  };

  const { form, onFinish, submitting } = useSubmit(submit, success);

  return (
    <Form
      form={form}
      layout="vertical"
      requiredMark="optional"
      onFinish={onFinish}
      initialValues={{
        float: 0,
        float_currency: config.BASE_CURRENCY,
        odds_format: ODDS_FORMATS.FRACTIONAL.value,
        target_payout: 1500,
      }}
      style={{ maxWidth: 500, margin: "auto" }}
    >
      <Row gutter={16}>
        <Col span={24}>
          <Title level={5} style={{ marginBottom: "2em" }}>
            Add {user.first_name} {user.last_name} ({user.username}) as a runner
          </Title>
        </Col>
        <Col span={14}>
          <Form.Item
            name="float"
            label="Initial Float"
            rules={[
              { required: true, message: "Please provide initial float." },
            ]}
          >
            <InputMoney symbol={currencySymbol} />
          </Form.Item>
        </Col>
        <Col span={10}>
          <Form.Item
            name="float_currency"
            label="Currency"
            rules={[{ required: true, message: "Please select a currency." }]}
          >
            <Select
              onChange={(v) => setCurrencySymbol(getCurrencySymbol(v))}
              options={currencyOptions}
            />
          </Form.Item>
        </Col>
        <Col span={24}>
          <Form.Item
            name="target_payout"
            label="Betting Level"
            rules={[
              { required: true, message: "Please enter a betting level." },
            ]}
          >
            <InputMoney symbol={currencySymbol} />
          </Form.Item>
        </Col>
        <Col span={24} align="middle">
          <Form.Item>
            <Button type="primary" htmlType="submit" loading={submitting}>
              Create Runner
            </Button>
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};

export default NewStaffRunner;
